import { EmploymentType } from '@thesavingsgroup/enums/EmploymentType';

export const employedTypes = [
  EmploymentType.ACTIVE_MILITARY,
  EmploymentType.FULL_TIME,
  EmploymentType.PART_TIME,
  EmploymentType.SELF_EMPLOYED,
];
